<template>
	<div class="i-font-tester">
		<div class="container">
			<div class="font-variant" v-for="font in fonts">
				<p>{{font}}</p>
				<p  :style="font">ABCDEFGHIJKLMNOPQRSTUVWXYZ<br/>
				abcdefghijklmnopqrstuvwxyz</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
props:["fonts"],
  name: 'i-font-tester',

  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
.font-variant{
	line-height: 1;
}
</style>